import { useEffect } from "react";
import { useLocation } from "wouter";

export default function LoginRedirect() {
  const [, navigate] = useLocation();
  useEffect(() => {
    navigate("/auth?tab=login", { replace: true });
  }, [navigate]);
  return null;
}